import React from 'react';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { ToolbarType } from '../types';

// Ignored via go/ees005
// eslint-disable-next-line import/no-named-as-default
import ToolbarTextColor from './ToolbarTextColor';
export function PrimaryToolbarComponent(_ref) {
  var api = _ref.api,
    isReducedSpacing = _ref.isReducedSpacing,
    editorView = _ref.editorView,
    popupsMountPoint = _ref.popupsMountPoint,
    popupsScrollableElement = _ref.popupsScrollableElement,
    popupsBoundariesElement = _ref.popupsBoundariesElement,
    dispatchAnalyticsEvent = _ref.dispatchAnalyticsEvent,
    disabled = _ref.disabled;
  var _useSharedPluginState = useSharedPluginState(api, ['textColor']),
    textColorState = _useSharedPluginState.textColorState;
  return /*#__PURE__*/React.createElement(ToolbarTextColor
  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  , {
    pluginState: textColorState,
    isReducedSpacing: isReducedSpacing,
    editorView: editorView,
    popupsMountPoint: popupsMountPoint,
    popupsBoundariesElement: popupsBoundariesElement,
    popupsScrollableElement: popupsScrollableElement,
    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
    disabled: disabled,
    pluginInjectionApi: api,
    toolbarType: ToolbarType.PRIMARY
  });
}